export default __webpack_public_path__ + "static/media/lighting.a8da5b13.svg";